import { Link, useLocation } from '@tanstack/react-router';
import { useHead } from '@unhead/react';
import { Button, Result } from 'antd';

export function NotFoundPage() {
    const location = useLocation();
    const isAdmin = location.pathname.includes('/admin');

    useHead({ title: 'Página não encontrada' });

    return (
        <div className='flex min-h-[80vh] w-full items-center justify-center bg-gray-100'>
            <Result
                className='rounded-lg bg-white p-10 shadow-lg'
                extra={
                    <Link className='btn btn-outline-primary w-full' to={isAdmin ? '/admin' : '/'}>
                        <Button type='primary'>Voltar para a página inicial</Button>
                    </Link>
                }
                status='404'
                subTitle='Desculpe, a página que você procura não existe.'
                title='404'
            />
        </div>
    );
}
